"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = normalizeProgram;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var linkedContent = function linkedContent(response) {
  if (response.length === 1) {
    return response[0].data;
  }

  var program = response.find(function (item) {
    return item.type === 'program';
  });
  var linkedContent = response.filter(function (item) {
    return item !== program;
  }).map(function (content) {
    return {
      id: content.id,
      type: content.type,
      content: content.data
    };
  });
  return _objectSpread(_objectSpread({}, program.data), {}, {
    linkedContent: linkedContent
  });
};

function normalizeProgram(response) {
  return response && response[0] && linkedContent(response);
}